import { create } from 'zustand';
import { CourseCombineData } from 'types/lcms/courseCombine';

type Mode = 'add' | 'edit' | 'view';

interface CourseCombineState {
  formData: CourseCombineData;
  mode: Mode;
  setFormData: (_data: Partial<CourseCombineData>) => void;
  setMode: (_data: Mode) => void;
  reset: () => void;
}

export const useCourseCombineStore = create<CourseCombineState>((set) => ({
  formData: {
    trainingRecommendationID: '',
    courseCode: '',
    courseFrom: '',
    courseName: '',
    courseId: '',
    updateAt: '',
    createdBy: ''
  },
  mode: 'add',
  setFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data }
    })),
  setMode: (data) => set(() => ({ mode: data })),
  reset: () =>
    set({
      formData: {
        trainingRecommendationID: '',
        courseCode: '',
        courseFrom: '',
        courseName: '',
        courseId: '',
        updateAt: '',
        createdBy: ''
      },
      mode: 'add'
    })
}));
